(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .constant('ItemChooserConstants', {
            SORT_KIND_NONE: '',
            SORT_KIND_ALPHA: 'alphabetical',
            SORT_KIND_ALPHA_ASC: '(A -> Z)',
            SORT_KIND_ALPHA_DESC: '(Z -> A)',
            SORT_KIND_NUMERIC: 'numeric',
            SORT_KIND_NUMERIC_ASC: '(Low -> High)',
            SORT_KIND_NUMERIC_DESC: '(High -> Low)',
            SORT_KIND_DATE: 'date',
            SORT_KIND_DATE_ASC: '(Earliest -> Latest)',
            SORT_KIND_DATE_DESC: '(Latest -> Earliest)',
            // Custom sort with no reverse (dash prefix) option
            SORT_KIND_CUSTOM: 'custom',
            // Sort with ONLY a reverse (dash prefix) option
            SORT_KIND_REVERSE_ONLY: 'reverse-only',
            DEFAULT_TEMPLATE_URL: 'item-chooser/item.tpl.html',
            YES_NO_VALUES: [
                {
                    id: 'true',
                    display: 'Yes'
                },
                {
                    id: 'false',
                    display: 'No'
                }
            ]
        });
})();